import { Menu } from "antd"
import Link from "next/link"
import {
  DollarCircleOutlined,
  EyeOutlined,
  InboxOutlined
} from "@ant-design/icons"
import PropTypes from "prop-types"
import ConfidentialityDisclaimer from "./confidentiality-disclaimer"

AuditorMenu.propTypes = {
  step: PropTypes.any,
  submenu: PropTypes.any
}

export default function AuditorMenu({ step, submenu }) {

  return (
    <>
      <Menu
        defaultSelectedKeys={[step]}
        defaultOpenKeys={[submenu]}
        theme="dark"
        className="fico main-menu"
        mode="inline">
        <Menu.SubMenu
          key="submissions"
          icon={<InboxOutlined />}
          title="Solicitudes">
          <Menu.Item key="SUBMISSIONS_RESUME">
            <Link href={"/dashboards/submissions"}>
              Resumen de solicitudes por aprobar
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_AGREEMENT">
            <Link href="/admin/submissions/status/on_agreement">
              Convenio
            </Link>
          </Menu.Item>
          <Menu.Item key="REJECTED">
            <Link href="/admin/submissions/status/rejected">
              Rechazadas
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu
          key="projects"
          icon={<EyeOutlined />}
          title="Monitoreo de proyectos">
          <Menu.Item key="PROJECTS_RESUME">
            <Link href={"/dashboards/projects"}>
              Resumen de proyectos aprobados
            </Link>
          </Menu.Item>
          <Menu.Item key="active">
            <Link href="/admin/projects">
              Activos
            </Link>
          </Menu.Item>
          <Menu.Item key="ON_CLOSURE">
            <Link href="/admin/projects/status/on_closure">
              Concluidos
            </Link>
          </Menu.Item>
        </Menu.SubMenu>
        <Menu.Item icon={<DollarCircleOutlined />} key="BUDGET_AVAILABILITY">
          <Link href={"/admin/budget-availability"}>
            Disponibilidad presupuestal
          </Link>
        </Menu.Item>
      </Menu>
      <ConfidentialityDisclaimer />
    </>
  )
}
